import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Grid, IconButton, Radio, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useUpdateCompany } from '../../../hooks/useCompany';
import { useUserStore } from '../../../stores/userStore';

const AddressCard = (props) => {
  const navigate = useNavigate();

  const companyInfo = useUserStore((state) => state.companyInfo);
  const setCompanyInfo = useUserStore((state) => state.setCompanyInfo);

  const { mutateAsync: updateCompany } = useUpdateCompany();

  const handleRadioChange = async (e) => {
    props.setSelected(e.target.value);

    try {
      const newAddressList = companyInfo.address.map((address) => {
        if (address._id === e.target.value) {
          return {
            ...address,
            default: true,
          };
        }
        return {
          ...address,
          default: false,
        };
      });

      const response = await updateCompany({
        params: {
          id: companyInfo._id,
        },
        dto: {
          address: newAddressList,
        },
      });

      if (response.Code === '20100') {
        setCompanyInfo(response.Data);
        navigate(-1);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box
      sx={{
        padding: '15px',
        marginBottom: '20px',
        backgroundColor: 'white',
        borderRadius: '8px',
        position: 'relative',
      }}
    >
      <Grid container mb={2}>
        <Grid item xs={4}>
          <Radio
            name={props.addressId}
            checked={props.selected === props.addressId}
            value={props.addressId}
            onChange={handleRadioChange}
            sx={{
              padding: '0',
              color: '#004B61',
              '&.Mui-checked': {
                color: '#004B61',
              },
            }}
          />
        </Grid>

        <Grid item xs={8} display="flex" justifyContent="flex-end" gap={1.5}>
          <IconButton
            aria-label="edit"
            sx={{ padding: '0', color: '#014B60' }}
            onClick={() => navigate(`/address/edit/${props.addressId}`)}
          >
            <EditIcon sx={{ fontSize: '1.25rem' }} />
          </IconButton>
          {props.selected !== props.addressId && (
            <IconButton
              aria-label="delete"
              sx={{ padding: '0', color: '#014B60' }}
              onClick={() => props.onDelete(props.addressId)}
            >
              <DeleteForeverIcon sx={{ fontSize: '1.25rem' }} />
            </IconButton>
          )}
        </Grid>
      </Grid>

      <Grid container rowGap={0.5}>
        {/* Name */}
        <Grid item xs={4}>
          <LabelField>ชื่อ - นามสกุล</LabelField>
        </Grid>
        <Grid item xs={8}>
          <ValueField>{props.name || '-'}</ValueField>
        </Grid>

        {/* Phone */}
        <Grid item xs={4}>
          <LabelField>เบอร์โทรศัพท์</LabelField>
        </Grid>
        <Grid item xs={8}>
          <ValueField>{props.phonenumber || '-'}</ValueField>
        </Grid>

        {/* Address */}
        <Grid item xs={4}>
          <LabelField>ที่อยู่</LabelField>
        </Grid>
        <Grid item xs={8}>
          <ValueField>{props.detail || ''}</ValueField>
        </Grid>

        {/* Alley */}
        <Grid item xs={4}>
          <LabelField>ซอย</LabelField>
        </Grid>
        <Grid item xs={8}>
          <ValueField>{props.alley || '-'}</ValueField>
        </Grid>

        {/* Street */}
        <Grid item xs={4}>
          <LabelField>ถนน</LabelField>
        </Grid>
        <Grid item xs={8}>
          <ValueField>{props.street || '-'}</ValueField>
        </Grid>

        {/* Subdistrict */}
        <Grid item xs={4}>
          <LabelField>ตำบล</LabelField>
        </Grid>
        <Grid item xs={8}>
          <ValueField>{props.subdistrict || '-'}</ValueField>
        </Grid>

        {/* District */}
        <Grid item xs={4}>
          <LabelField>อำเภอ</LabelField>
        </Grid>
        <Grid item xs={8}>
          <ValueField>{props.district || '-'}</ValueField>
        </Grid>

        {/* Province */}
        <Grid item xs={4}>
          <LabelField>จังหวัด</LabelField>
        </Grid>
        <Grid item xs={8}>
          <ValueField>{props.province || '-'}</ValueField>
        </Grid>

        {/* Zipcode */}
        <Grid item xs={4}>
          <LabelField>รหัสไปรษณีย์</LabelField>
        </Grid>
        <Grid item xs={8}>
          <ValueField>{props.zipcode || '-'}</ValueField>
        </Grid>
      </Grid>
    </Box>
  );
};

const LabelField = ({ children }) => {
  return (
    <Typography sx={{ fontSize: '1.25rem', fontWeight: '500', color: '#014B60' }}>
      {children}
    </Typography>
  );
};

const ValueField = ({ children }) => {
  return (
    <Typography
      sx={{
        padding: '4px 8px',
        backgroundColor: '#F5F5F5',
        fontSize: '1.25rem',
        fontWeight: '500',
        color: '#E1000C',
        wordBreak: 'break-word',
        borderRadius: '4px',
      }}
    >
      {children}
    </Typography>
  );
};

export default AddressCard;
